const FileList = () => import('@/vuepage/file-manage/FileList');
const FileDetail = () => import('@/vuepage/file-manage/FileDetail');


export default [
  {
    path: '/file-list',
    component: FileList,
    meta: [
      {
        name: '文件管理'
      },
      {
        name: '文件列表',
        activeRoute: '/file-list'
      }
    ]
  },
  {
    path: '/file-detail',
    component: FileDetail,
    meta: [
      {
        name: '文件管理'
      },
      {
        name: '文件列表',
        url: '/file-list'
      },
      {
        name: '文件详情',
        activeRoute: '/file-list'
      }
    ]
  },
]